import { h } from 'preact';
import { GiftboxProduct } from '../giftbox-product';
import { GiftboxGroupTab } from '../giftbox-group-tab';
import { t } from '../../../theme/locales';
const StepChooseGiftbox = ({ state , setState , giftboxProducts =null , diyGiftboxProducts =null , hideComplimentaryMessage =false  })=>{
    const assembledProducts = giftboxProducts ? Object.entries(giftboxProducts) : [];
    const diyProducts = diyGiftboxProducts ? Object.entries(diyGiftboxProducts) : [];
    const allProducts = [
        ...assembledProducts.map(([handle, product])=>[
                handle,
                product,
                false
            ]),
        ...diyProducts.map(([handle, product])=>[
                handle,
                product,
                true
            ])
    ];
    var _state_giftboxGroup;
    const activeGroup = (_state_giftboxGroup = state.giftboxGroup) !== null && _state_giftboxGroup !== void 0 ? _state_giftboxGroup : allProducts.length > 0 ? 'assembled' : 'message';
    if (!assembledProducts.length && !diyProducts.length) {
        return h('div', {}, t('gift_wrapping.steps.choose_giftbox.no_giftboxes'));
    }
    return h('div', {
        className: 'giftbox-groups',
        'data-testid': 'gift-wrapping-giftbox-groups',
        role: 'radiogroup',
        'aria-label': t('gift_wrapping.steps.choose_giftbox.group_label')
    }, [
        h(GiftboxGroupTab, {
            value: 'assembled',
            activeGroup,
            title: t('gift_wrapping.group_tabs.assembled.title', ''),
            description: t('gift_wrapping.group_tabs.assembled.description', ''),
            price: null,
            onSelect: ()=>setState({
                    giftboxGroup: 'assembled',
                    giftbox: '',
                    variant: '',
                    items: [],
                    isDiy: false
                })
        }, h('div', {
            className: 'giftbox-group__products'
        }, [
            h('div', {
                className: 'giftbox-group__title'
            }, t('gift_wrapping.steps.choose_giftbox.product_list_title')),
            h('div', {
                className: 'giftbox-group__options'
            }, allProducts.map(([handle, product, isDiy])=>h(GiftboxProduct, {
                    key: `${handle}-${isDiy ? 'diy' : 'giftbox'}`,
                    handle,
                    product,
                    state,
                    setState: (nextState)=>{
                        if (Object.prototype.hasOwnProperty.call(nextState, 'giftbox') || Object.prototype.hasOwnProperty.call(nextState, 'isDiy')) {
                            setState({
                                ...nextState,
                                giftboxGroup: 'assembled'
                            });
                            return;
                        }
                        setState(nextState);
                    },
                    isDiy
                })))
        ])),
        !hideComplimentaryMessage ? h(GiftboxGroupTab, {
            value: 'message',
            activeGroup,
            title: t('gift_wrapping.group_tabs.complimentary_message.title'),
            description: t('gift_wrapping.group_tabs.complimentary_message.description'),
            price: null,
            onSelect: ()=>setState({
                    giftboxGroup: 'message',
                    giftbox: '',
                    variant: '',
                    items: [],
                    isDiy: false
                })
        }) : null
    ]);
};
export default StepChooseGiftbox;
